import { Segmented, Tooltip } from 'antd';

import { NewsletterAudience } from '@hooks-api';

import { AUDIENCE_COPY } from './audience';

interface Props {
  value: NewsletterAudience;
  onChange: (next: NewsletterAudience) => void;
  disabled?: boolean;
}

/**
 * Picks which pool recipients are drawn from (ENG-1198): every in-service member,
 * or only those who opted in to marketing. Both pools are in-service companies
 * with a confirmed email, so the toggle only moves the consent filter.
 *
 * Switching audiences replaces the recipient list, so the caller resets the
 * selection (see the Newsletter page).
 */
const AudienceToggle = ({ value, onChange, disabled }: Props) => (
  <Segmented
    value={value}
    disabled={disabled}
    onChange={(next) => onChange(next as NewsletterAudience)}
    options={(Object.keys(AUDIENCE_COPY) as NewsletterAudience[]).map((audience) => ({
      value: audience,
      label: <Tooltip title={AUDIENCE_COPY[audience].hint}>{AUDIENCE_COPY[audience].label}</Tooltip>,
    }))}
  />
);

export default AudienceToggle;
